var map = {
	"./albergolosone.jpg": [
		5982,
		8279
	],
	"./ameronswissmountain.jpg": [
		3813,
		1415
	],
	"./artdecomontana.jpg": [
		5189,
		4898
	],
	"./arthotel-riposo.jpg": [
		83,
		9379
	],
	"./ascovilla.jpg": [
		8804,
		1956
	],
	"./atlantis.jpg": [
		9993,
		7776
	],
	"./backstage-vernissage.jpg": [
		2391,
		945
	],
	"./badrutt-s-palace.jpg": [
		3401,
		3921
	],
	"./baur-au-lac.jpg": [
		6175,
		6738
	],
	"./beatus.jpg": [
		155,
		4239
	],
	"./beaurivage.jpg": [
		3773,
		6783
	],
	"./beaurivagepalace.jpg": [
		9690,
		4466
	],
	"./bergwelt-grindelwald.jpg": [
		4240,
		8929
	],
	"./bodmi.jpg": [
		5070,
		1522
	],
	"./buergenstock.jpg": [
		4738,
		5764
	],
	"./castello_del_sole.jpg": [
		8622,
		9094
	],
	"./chedi.jpg": [
		2627,
		3504
	],
	"./chesa-randolina.jpg": [
		2115,
		6995
	],
	"./de_rougemont.jpg": [
		1597,
		1831
	],
	"./deltapark.jpg": [
		4785,
		3663
	],
	"./doldenhorn.jpg": [
		37,
		5940
	],
	"./dolder-grand.jpg": [
		6185,
		2909
	],
	"./eden-roc.jpg": [
		6630,
		9605
	],
	"./ermitage.jpg": [
		4761,
		9246
	],
	"./fairmontlemontreux.jpg": [
		975,
		6314
	],
	"./fourseasons.jpg": [
		9811,
		497
	],
	"./fruttfamilylodge.jpg": [
		3355,
		8487
	],
	"./giardino.jpg": [
		6135,
		7739
	],
	"./ginabelle.jpg": [
		6731,
		9197
	],
	"./golfpanorama.jpg": [
		9013,
		4333
	],
	"./grandhotelquellenhof.jpg": [
		728,
		6678
	],
	"./gstaad-palace.jpg": [
		689,
		8674
	],
	"./hof_weissbad.jpg": [
		7863,
		2904
	],
	"./huus-gstaad.jpg": [
		1214,
		9336
	],
	"./kempinski.jpg": [
		4257,
		4672
	],
	"./kulm.jpg": [
		2271,
		9731
	],
	"./la-reserve-geneve.jpg": [
		6419,
		2693
	],
	"./le-grand-bellevue.jpg": [
		5883,
		9079
	],
	"./lenkerhof.jpg": [
		8363,
		1336
	],
	"./lestroisrois.jpg": [
		4998,
		4804
	],
	"./maerchenhotelbraunwald.jpg": [
		7856,
		2124
	],
	"./mandarin-oriental.jpg": [
		3445,
		4378
	],
	"./mirador.jpg": [
		9686,
		872
	],
	"./nira-alpina.jpg": [
		3453,
		4324
	],
	"./parkhotel-delta.jpg": [
		785,
		8025
	],
	"./parkhotel-margna.jpg": [
		873,
		4396
	],
	"./pirmin-zurbriggen.jpg": [
		7297,
		4431
	],
	"./placeholder.jpg": [
		7624,
		8242
	],
	"./priva.jpg": [
		4584,
		1878
	],
	"./radissonblue.jpg": [
		8524,
		5929
	],
	"./rocksresort.jpg": [
		7974,
		5623
	],
	"./romantik-hotel-julen-zermatt.jpg": [
		9622,
		8159
	],
	"./saratz.jpg": [
		5420,
		8846
	],
	"./schweizerhof.jpg": [
		1394,
		1906
	],
	"./schweizerhofbern.jpg": [
		2121,
		6550
	],
	"./spitzhorn.jpg": [
		2372,
		7225
	],
	"./sunstar-arosa.jpg": [
		4206,
		8885
	],
	"./suvretta-house.jpg": [
		4028,
		1788
	],
	"./swiss_holiday_park.jpg": [
		189,
		3264
	],
	"./the-alpina.jpg": [
		8102,
		1063
	],
	"./thehide.jpg": [
		6543,
		4033
	],
	"./tschuggen.jpg": [
		8768,
		859
	],
	"./ultima-gstaad.jpg": [
		5218,
		8482
	],
	"./valbella-resort.jpg": [
		8862,
		4858
	],
	"./valbellainn.jpg": [
		3327,
		5045
	],
	"./valsana.jpg": [
		778,
		579
	],
	"./victoriajungfrau.jpg": [
		9505,
		3457
	],
	"./vitznauerhof.jpg": [
		9053,
		8823
	],
	"./widder.jpg": [
		9193,
		2177
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9889;
module.exports = webpackAsyncContext;